import { useState, useEffect } from "react";
import RichTextEditor from "../../../common/richTextEditor";
import { useTranslation } from "react-i18next";
import { canAction } from "../../../common/permissionhelper";
const MODULE = "manage_foodservicepartners";
const SectorsSectionEditor = ({ section, onUpdate, onSave, isSaving }) => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit;
  const [formData, setFormData] = useState(section || { description: "" });
  // Initialize form data when section prop changes
  useEffect(() => {
    setFormData(section || { description: "" });
  }, [section]);
  // Handle rich text editor changes
  const handleRichTextChange = (html) => {
    const updatedData = {
      ...formData,
      description: html,
    };
    setFormData(updatedData);
    if (onUpdate) onUpdate(updatedData);
  };
  // Render form fields
  return (
    <div className="section-editor">
      {/* Section Title */}
      <div className="input-field">
        <label>{t("section_title_txt")}</label>
        <RichTextEditor
          emailContent={formData.title || ""}
          handleChangeEmailContent={(html) => {
            const updatedData = {
              ...formData,
              title: html,
            };
            setFormData(updatedData);
            if (onUpdate) onUpdate(updatedData);
          }}
          readOnly={isReadOnly}
        />
      </div>
      {/* Section Description */}
      <div className="input-field">
        <label>{t("section_description_txt")}</label>
        <RichTextEditor
          emailContent={formData.description || ""}
          handleChangeEmailContent={handleRichTextChange}
          readOnly={isReadOnly}
        />
      </div>
      {!isReadOnly && (
      <div className="btnfield">
        <button
          type="button"
          onClick={() => onSave && onSave("sectors", formData)}
          disabled={isSaving}
        >
          {isSaving ? t("saving_txt") : t("save_section_txt")}
        </button>
      </div>
      )}
    </div>
  );
};

export default SectorsSectionEditor;